import { initEndpointHealthCheck } from '@infinitro/config';

export const prerender = false;
export const ssr = false;
export const trailingSlash = 'always';

export const load = async () => {
	await initEndpointHealthCheck();
};
